<template>
	<div>
		<h1>Cette page n'existe pas !</h1>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
	};
</script>

<style></style>
